export default {
  manage_deletedKeyFob: "Key Fob was deleted successfully",
  manage_deletedKeyFobs: "Key Fobs were deleted successfully",
  manage_deleteManageKeyFob_confirmationMessage:
    "Are you sure you want to delete the following Key Fobs?",
  manage_deleteManageKeyFob_deleteKeyFob: "Delete Key Fob",
  manage_deleteManageKeyFob_deleteKeyFobs: "Delete Key Fobs",
};
